/**
 * @generated SignedSource<<cc8e0bed88df82b5a7d6c2af583721fe>>
 * @relayHash 2621483f280686ae275d185cb5eccc3a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44de10d63756986e7c9f75eb8db324cc05ba174eded0937f4a66dcbf6691c563

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConvoAiHomeThreadsInput = {
  promptOverride?: string | null | undefined;
  userId: string;
};
export type ThreadsV2_Query$variables = {
  cloudId: string;
  experience: string;
  homeThreadsInput: ConvoAiHomeThreadsInput;
  isEnabled: boolean;
  suggestedActionsV2Enabled: boolean;
};
export type ThreadsV2_Query$data = {
  readonly convoai_homeThreads?: {
    readonly " $fragmentSpreads": FragmentRefs<"RecommendedFeedInternal_AtlassianRecommendedFeed">;
  } | null | undefined;
};
export type ThreadsV2_Query = {
  response: ThreadsV2_Query$data;
  variables: ThreadsV2_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "experience"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "homeThreadsInput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "suggestedActionsV2Enabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "kind": "Variable",
    "name": "homeThreadsInput",
    "variableName": "homeThreadsInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "url"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "ConvoAiHomeThreadsThirdPartySource"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = [
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ThreadsV2_Query",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConvoAiHomeThreadsResult",
            "kind": "LinkedField",
            "name": "convoai_homeThreads",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "suggestedActionsV2Enabled",
                    "variableName": "suggestedActionsV2Enabled"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "RecommendedFeedInternal_AtlassianRecommendedFeed"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ThreadsV2_Query",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConvoAiHomeThreadsResult",
            "kind": "LinkedField",
            "name": "convoai_homeThreads",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConvoAiHomeThreadsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ConvoAiHomeThread",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "summary"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "sources",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isConvoAiHomeThreadSource"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "ari"
                              },
                              (v5/*: any*/)
                            ],
                            "type": "ConvoAiHomeThreadsFirstPartySource"
                          },
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "ConvoAiHomeThreadSuggestedAction",
                        "kind": "LinkedField",
                        "name": "suggestedActions",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "source",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v7/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ConvoAiHomeThreadsFirstPartySource"
                              },
                              (v6/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "action"
                          },
                          {
                            "condition": "suggestedActionsV2Enabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "data",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v8/*: any*/),
                                              {
                                                "concreteType": "ConfluenceUserInfo",
                                                "kind": "LinkedField",
                                                "name": "author",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                      (v4/*: any*/),
                                                      (v8/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "picture"
                                                      },
                                                      (v2/*: any*/)
                                                    ]
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                  },
                                                  (v2/*: any*/)
                                                ]
                                              },
                                              {
                                                "concreteType": "ConfluenceContentVersion",
                                                "kind": "LinkedField",
                                                "name": "latestVersion",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "createdAt"
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "ConfluenceBodies",
                                                "kind": "LinkedField",
                                                "name": "body",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "args": [
                                                      {
                                                        "kind": "Literal",
                                                        "name": "length",
                                                        "value": 300
                                                      }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "excerpt",
                                                    "storageKey": "excerpt(length:300)"
                                                  }
                                                ]
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "name": "container",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v3/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "subtype"
                                                      }
                                                    ],
                                                    "type": "ConfluencePage"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": (v9/*: any*/),
                                                    "type": "ConfluenceBlogPost"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": (v9/*: any*/),
                                                    "type": "ConfluenceWhiteboard"
                                                  },
                                                  (v7/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "ConfluenceFooterComment"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "ConvoAiHomeThreadsFirstPartySource"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "44de10d63756986e7c9f75eb8db324cc05ba174eded0937f4a66dcbf6691c563",
    "metadata": {},
    "name": "ThreadsV2_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "164d0eebed4738877139818c541a2de0";

export default node;
